import { render, staticRenderFns } from "./belowHalfTimeProduct.vue?vue&type=template&id=1e70938e&scoped=true"
import script from "./belowHalfTimeProduct.vue?vue&type=script&lang=js"
export * from "./belowHalfTimeProduct.vue?vue&type=script&lang=js"
import style0 from "./belowHalfTimeProduct.vue?vue&type=style&index=0&id=1e70938e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e70938e",
  null
  
)

export default component.exports